import React from 'react';
import { Menu } from '@headlessui/react';
import { CaretDown } from '@phosphor-icons/react';

interface Option {
  value: string;
  label: string;
}

interface SelectProps {
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  className?: string;
  isDisabled?: boolean;
}

export function Select({ value, onChange, options, className = '', isDisabled = false }: SelectProps) {
  const selectedOption = options.find(opt => opt.value === value) || options[0];

  return (
    <Menu as="div" className="relative">
      <Menu.Button 
        disabled={isDisabled}
        className={`flex items-center gap-2 px-4 py-2 bg-[#F5EEE8] rounded-lg hover:bg-[#EBE2DA] transition-colors ${
          isDisabled ? 'opacity-50 cursor-not-allowed' : ''
        } ${className}`}
      >
        <span className="text-[#361E06] font-medium">{selectedOption.label}</span>
        <CaretDown className="w-4 h-4 text-[#361E06]" weight="bold" />
      </Menu.Button>

      <Menu.Items className="absolute z-50 mt-2 w-full bg-white rounded-lg shadow-lg border border-gray-200 py-1 max-h-[300px] overflow-y-auto">
        {options.map((option) => (
          <Menu.Item key={option.value}>
            {({ active }) => (
              <button
                onClick={() => onChange(option.value)}
                className={`${
                  active ? 'bg-gray-50' : ''
                } w-full text-left px-4 py-2 text-[#361E06]`}
              >
                {option.label}
              </button>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
} 